import { combineReducers } from "redux";
import candidate from "./candidateReducer";
import candidateLists from "./candidateListsReducer";
import internalUsers from "./internalUsersReducer";
import bookings from "./bookingsReducer";
import clientLogin from "./clientLoginReducer";
import client from "./clientReducer";
import apiCallsInProgress from "./apiStatusReducer";
import chat from "@src/components/chat/store";

import layout from "./layout";
import navbar from "./navbar";
import createStatusReducer from "redux-api-status";
import calendar from "@src/components/CandidateProfile/Diary/store";
const rootReducer = combineReducers({
  candidate,
  candidateLists,
  client,
  bookings,
  internalUsers,
  clientLogin,
  navbar,
  chat,
  layout,
  calendar,
  apiCallsInProgress,
  status: createStatusReducer(),
});

export default rootReducer;
